import React, { Component } from "react";
import ChartistGraph from "react-chartist";
import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  Table,
} from "react-bootstrap";

import Slider from "react-slick";

import Button from "../../components/CustomButton/CustomButton.jsx";
import InputMask from "react-input-mask";

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";

import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import { StatsCard } from "../../components/StatsCard/StatsCard.jsx";

import TrailList from "../../components/Trail/List.jsx";

const restLink_dam = new HttpLink({
  uri: "/api/v1/dam/",
  credentials: "include",
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});

const restLink_lms = new HttpLink({
  uri: "/api/v1/lms/",
  credentials: "include",
});
const lms_client = new ApolloClient({
  link: restLink_lms,
  cache: new InMemoryCache(),
});

const restLink_cms = new HttpLink({
  uri: "/api/v1/cms/",
  credentials: "include",
});
const cms_client = new ApolloClient({
  link: restLink_cms,
  cache: new InMemoryCache(),
});

const restLink_analytics = new HttpLink({
  uri: "/api/v1/analytics/",
  credentials: "include",
});
const analytics_client = new ApolloClient({
  link: restLink_analytics,
  cache: new InMemoryCache(),
});

const restLink_account = new HttpLink({
  uri: "/api/v1/account/",
  credentials: "include",
});
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});



const GET_TRAILS = gql`
  {
  trails_collections{
    trails{
      id
      title
    }
  }
}
`;

const GET_TRAILITEMS = gql`
  query trailitems($trail_id: Int!) {
    trailitems(trail_id: $trail_id) {
      trailitems {
        id
        item_id
        item_type
        ordernum
      }
    }
  }
`;

const GET_ASSET = gql`
  query asset($id: Int!) {
    asset(id: $id) {
      id
      title
      asset
    }
  }
`;

const GET_COURSE = gql`
  query course($id: Int!) {
    course(id: $id) {
      id
      title
      description
      scorm
      hours
      minutes
      thumbnail
      code
      video {
        id
        thumbnail
        uuid
      }
      proof {
        id
        title
      }
      reactionevaluation {
        id
        title
      }
    }
  }
`;

const TRAIL_REPORT = gql`
  query trailReport($trail_id: Int!, $user_id: Int) {
    trailReport(trail_id: $trail_id, user_id: $user_id) {
      trailreport {
        user {
          id
          name
          mail
          type
        }
        trailCompleted
        evaluationGradeProof {
          totalQuestions
          rightQuestions
        }
        evaluationGradeReaction {
          totalQuestions
          rightQuestions
        }
        trailItemReport {
          trailItem {
            id
            item_type
            item_id
          }
          timeReproduced
          time
          isCompleted
          timestamp_format_br
        }
      }
    }
  }
`;

class ReportUsers extends Component {
  constructor() {
    super();
    this.state = {};
  }

  exportTableToExcel(e) {
    var downloadLink;
    var dataType = "application/vnd.ms-excel";
    var tableSelect = document.getElementById("myTable");

    //console.log(tableSelect);

    var tableHTML =
      '<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /></head><body>' +
      tableSelect.outerHTML.replace(/ /g, "%20") +
      "</body></html>";
    var filename = "Relatorio-Trilha";
    // Specify file name
    filename = filename ? filename + ".xls" : "excel_data.xls";

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(["\ufeff", tableHTML], {
        type: dataType,
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = "data:" + dataType + ", " + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
    e.preventDefault();
  }

  render() {
    return (
      <div className="container_full_width ">
        <a href="/#/home" className="btn btn-primary btn-fill">
          Voltar para Primeira Página
        </a>
        <Button bsStyle="info" fill onClick={this.exportTableToExcel}>
          Exportar
        </Button>
        <div className="pageReport">
          <Table id="myTable" bordered striped hover border={1}>
            <tbody>

            <Query
                client={lms_client}
                fetchPolicy="no-cache"
                query={GET_TRAILS}
              >
                {({ loading, error, data }) => {
                  if (loading)
                    return (
                      <tr>
                        <td>Carregando...</td>
                      </tr>
                    );
                  if (error)
                    return (
                      <tr>
                        <td>Erro :(</td>
                      </tr>
                    );

                    return data.trails_collections.trails.map((trail) => (

                          <Query
                            client={lms_client}
                            fetchPolicy="no-cache"
                            variables={{ 
                              trail_id: trail.id,
                              user_id: this.props.match.params.user_id
                            }}
                            query={TRAIL_REPORT}
                          >
                            {({ loading, error, data }) => {
                              if (loading)
                                return (
                                  <tr>
                                    <td>Carregando...</td>
                                  </tr>
                                );
                              if (error)
                                return (
                                  <tr>
                                    <td>Erro :(</td>
                                  </tr>
                                );

                              var trailReport = data.trailReport.trailreport;

                              return (
                                <React.Fragment>
                                  <tr>
                                    <th class="px-1">Curso</th>
                                    <th class="px-1">Nome</th>
                                    <td class="px-1">Perfil do cadastro</td>
                                    <th class="px-1">E-mail</th>
                                    <Query
                                      client={lms_client}
                                      fetchPolicy="no-cache"
                                      variables={{ trail_id: trail.id }}
                                      query={GET_TRAILITEMS}
                                    >
                                      {({ loading, error, data }) => {
                                        if (loading)
                                          return (
                                            <tr>
                                              <td>Carregando...</td>
                                            </tr>
                                          );
                                        if (error)
                                          return (
                                            <tr>
                                              <td>Erro :(</td>
                                            </tr>
                                          );

                                        var trailItens = data.trailitems.trailitems;

                                        return (
                                          <React.Fragment>
                                            {trailItens.map((trailItem) => (
                                              <React.Fragment>
                                                <th class="px-1">
                                                  {trailItem.item_type === "course" && (
                                                    <Query
                                                      client={lms_client}
                                                      query={GET_COURSE}
                                                      variables={{ id: trailItem.item_id }}
                                                    >
                                                      {({ loading, error, data }) => {
                                                        if (loading)
                                                        return (
                                                          <tr>
                                                            <td>Carregando...</td>
                                                          </tr>
                                                        );
                                                        if (error)
                                                          return (
                                                            <tr>
                                                              <td>Erro :(</td>
                                                            </tr>
                                                          );

                                                        if (!data.course) {
                                                          return <React.Fragment></React.Fragment>;
                                                        }
                                                        return (
                                                          <React.Fragment>
                                                            {data.course.title}
                                                          </React.Fragment>
                                                        );
                                                      }}
                                                    </Query>
                                                  )}
                                                  {trailItem.item_type === "asset" && (
                                                    <Query
                                                      client={dam_client}
                                                      query={GET_ASSET}
                                                      variables={{ id: trailItem.item_id }}
                                                    >
                                                      {({ loading, error, data }) => {
                                                        if (loading)
                                                          return (
                                                          <tr>
                                                            <td>Carregando...</td>
                                                          </tr>
                                                        );
                                                        if (error)
                                                          return (
                                                            <tr>
                                                              <td>Erro :(</td>
                                                            </tr>
                                                          );

                                                        if (!data.asset) {
                                                          return <React.Fragment></React.Fragment>;
                                                        }
                                                        return (
                                                          <React.Fragment>
                                                            {data.asset.title}
                                                          </React.Fragment>
                                                        );
                                                      }}
                                                    </Query>
                                                  )}
                                                </th>
                                                <th>Data/Hora da conclusão</th>
                                              </React.Fragment>
                                            ))}
                                          </React.Fragment>
                                        );
                                      }}
                                    </Query>
                                    <th>Prova</th>
                                    <th>Certificado</th>
                                  </tr>
                                  {trailReport.map((trailReportItem) => (
                                    <tr>
                                      <td class="px-1">{trail.title}</td>
                                      <td class="px-1">{trailReportItem.user.name}</td>
                                      <td class="px-1">{trailReportItem.user.type}</td>
                                      <td class="px-1">{trailReportItem.user.mail}</td>

                                      {trailReportItem.trailItemReport.map(
                                        (trailItemReport) => (
                                          <React.Fragment>
                                            <td class="px-1 desc">
                                              {trailItemReport.isCompleted === 1
                                                ? "Concluído"
                                                : "Não concluído "}
                                            </td>
                                            <td class="px-1 desc">
                                              {trailItemReport.timestamp_format_br}
                                              {/* <br />
                                              {trailItemReport.trailItem.item_type ===
                                                "course" && (
                                                <React.Fragment>
                                                  Assistiu {trailItemReport.timeReproduced}{" "}
                                                  de {trailItemReport.time}
                                                </React.Fragment>
                                              )} */}
                                            </td>
                                          </React.Fragment>
                                        )
                                      )}
                                      <td class="px-1 desc">
                                        <p>
                                          {" "}
                                          {
                                            trailReportItem.evaluationGradeProof
                                              .rightQuestions
                                          }{" "}
                                          de{" "}
                                          {
                                            trailReportItem.evaluationGradeProof
                                              .totalQuestions
                                          }
                                        </p>
                                      </td>
                                      <td class="px-1 desc">
                                        <p>
                                          {trailReportItem.trailCompleted === 1 && (
                                            <a
                                              target="_blank"
                                              href={
                                                "/api/v1/lms/certified_trail_generat?u=" +
                                                trail.id +
                                                "&u_id=" +
                                                trailReportItem.user.id
                                              }
                                              className="btn btn-primary btn-fill"
                                            >
                                              Certificado
                                            </a>
                                          )}
                                          {trailReportItem.trailCompleted === 0 && (
                                            <span>-</span>
                                          )}
                                        </p>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              );
                            }}
                          </Query>
                  ));
                }}
              </Query>
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default ReportUsers;



// WEBPACK FOOTER //
// ./src/views/Home/ReportUsers.jsx